function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBolt = function SvgBolt(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "frame"
  }, React.createElement("rect", {
    width: 256,
    height: 256,
    style: {
      fill: "none"
    }
  })), React.createElement("g", {
    id: "white"
  }, React.createElement("path", {
    d: "M140.48,23.39,36.85,147.74h93.27l-10.37,82.9L223.38,106.29H130.12Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("g", {
    id: "highlights"
  }, React.createElement("path", {
    d: "M143.35,25.11,51.6,128.34l119.47,1.32L124.21,191l-4.46,39.6L226.25,108H133Z",
    style: {
      fill: "#e8dbec"
    }
  })), React.createElement("g", {
    id: "primary"
  }, React.createElement("path", {
    d: "M139.13,24.05,35.51,148.4h93.26l-10.36,82.9L222,107H128.77Z",
    style: {
      fill: "none",
      stroke: "#4f4954",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }
  }))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bolt.1f779503.svg";
export { ForwardRef as ReactComponent };